import { configureStore } from "@reduxjs/toolkit";
import GrowerReducer from "./reducers/GrowerReducer";
import ConfigurationReducer from "./reducers/ConfigurationReducer";

// Handles CoreUI-style `{ type: "set", sidebarShow, sidebarUnfoldable }` actions
// dispatched by AppHeader / AppSidebar.
const setReducer = (key, initialValue) => (state = initialValue, action) =>
    action.type === "set" && key in action ? action[key] : state;

export const Store = configureStore({
    reducer: {
        growerReducer: GrowerReducer,
        configurationReducer: ConfigurationReducer,
        sidebarShow: setReducer("sidebarShow", true),
        sidebarUnfoldable: setReducer("sidebarUnfoldable", false),
    },

})
